import React from 'react'
import VBEventMatch from '../components/VBEventMatch'

const VBEventMatchView = ({ match }) => {
  return <VBEventMatch vbMatchId={match.params.id} />
}

export default VBEventMatchView
